<style lang="less" scoped>
  td {
    text-align: center;
    padding: 5px 5px;
    border: 2px solid #ebeef5;
  }

  table {
    margin-top: 10px;
    font-size: 14px;
    border-collapse: collapse;
    border: none;
  }

  .item-btn {
    height: 32px;
    line-height: 7px;
  }

  .disChange-body {
    width: 100%;
    display: flex;
    flex-direction: column;

    .body-item-title {
      width: 100%;
      font-size: 15px;
      font-weight: 600;
      margin-bottom: 32px;
      margin-top: 16px;
    }

    .body-item-radio{
      width: 100%;
      margin-bottom: 32px;
    }

    .body-item-timePeriod{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;

      .time-period-item {
        width: calc(100% / 3);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .item-font{
        font-size: 14px;
        font-weight: 600;
      }
    }

    .body-item-soc{
      width: 100%;
      display: flex;
      align-items: center;

      .soc-title {
        font-size: 14px;
        font-weight: 600;
      }

    }
  }

</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb" />
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
        <el-tab-pane label="交流桩" name="acPile"></el-tab-pane>
        <el-tab-pane label="直流桩" name="dcPile"></el-tab-pane>
        <el-tab-pane label="放电资费" name="discharge"></el-tab-pane>
      </el-tabs>
      <!-- 交流桩、直流桩 -->
      <div class="detail-content-body-div flex-1" v-if="activeName === 'acPile' || activeName === 'dcPile'">
        <el-form
          :model="detailForm"
          :rules="pageConfig.formRules"
          ref="detailForm"
          label-width="120px"
          class="detail-form"
        >
          <div class="flex detail-form-parent-div">
            <div class="flex-1">
              <el-form-item label="资费（元/度）" prop="ttlVal">
                <el-input
                  style="width:320px;"
                  v-model="detailForm.ttlVal"
                  size="small"
                  @input="ttlValChange"
                  :disabled="isflag"
                />
                <span style="margin-left:15px">更新人：{{ detailForm.lastModifiedByName }}</span>
                <span style="margin-left:15px">更新时间：{{ detailForm.lastModifiedWhen }}</span>
              </el-form-item>
              <div style="margin-bottom:16px;">
                <el-radio
                  v-model="detailForm.chargeType"
                  label="01"
                  @change="handleRadioChange('01')"
                  :disabled="isflag"
                >固定费用</el-radio>
                <table style="width:60%;height:150px;">
                  <tr>
                    <td>时段</td>
                    <td>00时至次日00时</td>
                  </tr>
                  <tr>
                    <td>基本电费(元/kW.h)</td>
                    <td>
                      <el-input
                        v-model="items1.charingcost"
                        size="small"
                        :disabled="isflag"
                        @input="handeleFeeChange1()"
                      ></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td>充电服务费(元/kW.h)</td>
                    <td>{{ items1.sercost }}</td>
                  </tr>
                </table>

                <div style="color: #ed3f14;font-size:12px;margin-top:10px;">
                  {{ tip1 }}
                </div>
              </div>
              <div>
                <el-radio
                  v-model="detailForm.chargeType"
                  label="02"
                  @change="handleRadioChange('02')"
                  :disabled="isflag"
                  >峰谷分时电费</el-radio
                >
                <table style="width:60%;height:150px;">
                  <tr>
                    <td>时段</td>
                    <td>
                      峰值&nbsp;
                      <el-time-picker
                        style="width:300px"
                        size="small"
                        is-range
                        v-model="valleyTime"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        value-format="HH:mm"
                        format="HH:mm"
                        :disabled="isflag"
                        @change="handleTimeChange"
                      />
                    </td>
                    <td>
                      谷值&nbsp;
                      <el-time-picker
                        style="width:300px"
                        size="small"
                        is-range
                        v-model="peaksTime"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        value-format="HH:mm"
                        format="HH:mm"
                        :disabled="isflag"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>基本电费(元/kW.h)</td>
                    <td>
                      <el-input
                        v-model="items2[0].charingcost"
                        size="small"
                        :disabled="isflag"
                        @input="handeleFeeChange21()"
                      />
                    </td>
                    <td>
                      <el-input
                        v-model="items2[1].charingcost"
                        size="small"
                        :disabled="isflag"
                        @input="handeleFeeChange22()"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>充电服务费(元/kW.h)</td>
                    <td>{{ items2[0].sercost }}</td>
                    <td>{{ items2[1].sercost }}</td>
                  </tr>
                </table>

                <div style="color: #ed3f14;font-size:12px;margin-top:10px;">
                  {{ tip2 }}
                </div>
                <div style="color: #ed3f14;font-size:12px;margin-top:10px;">
                  {{ tip3 }}
                </div>
              </div>
              <div class="flex" style="margin-top:16px;">
                <el-form-item label-width="0">
                  <el-radio
                    label="03"
                    v-model="detailForm.chargeType"
                    @change="handleRadioChange('03')"
                    :disabled="isflag"
                    >自定义分时电费</el-radio
                  >
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    size="small"
                    :disabled="isflag"
                    @click="addTime"
                    style="margin-right:10px;"
                    >增加时间段</el-button
                  >
                  <span style="color:#F56C6C;">{{ zdytip }}</span>
                </el-form-item>
              </div>
              <div
                v-for="(item, index) in items"
                :key="index"
                track-by="$index"
                class="flex"
              >
                <el-form-item label-width="0">
                  <div class="flex" style="margin-top:5px;">
                    <Input
                      v-model="item.startTime"
                      style="width: 112px"
                      :disabled="isflag"
                    />-
                    <TimePicker
                      :editable="false"
                      format="HH:mm"
                      v-model="item.endTime"
                      placeholder="Select time"
                      style="width: 112px"
                      :disabled="isflag"
                      @on-change="chgStartTime(index)"
                    />
                  </div>
                </el-form-item>
                <el-form-item
                  label="资费（元/kW-h）"
                  prop="matName"
                  label-width="170px"
                >
                  <el-input
                    style="width:200px;"
                    v-model="item.totalVal"
                    size="small"
                    :disabled="isflag"
                  />
                </el-form-item>
                <el-form-item
                  label="基本电费（元/度）"
                  prop="matName"
                  label-width="150px"
                >
                  <el-input
                    style="width:200px;"
                    v-model="item.charingcost"
                    size="small"
                    :disabled="isflag"
                    @input="handeleFeeChange3()"
                  />
                </el-form-item>
                <el-form-item
                  label="充电服务费（元/度）"
                  prop="matName"
                  label-width="170px"
                >
                  {{ item.sercost }}
                </el-form-item>
                <el-button
                  type="primary"
                  class="item-btn"
                  v-if="index != '0'"
                  @click="delTime(index)"
                  :disabled="isflag"
                  style="margin-left: 120px;"
                >删除</el-button>
                <div style="width:150px;color: #ed3f14;font-size:12px;margin:11px 0px 0px 10px;">
                  {{ item.tip }}
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <!-- 表格 -->
        <div class="list-table">
          <el-table :data="tableData" :stripe="true" class="list_tb" border>
            <el-table-column
              prop="operationUserAccount"
              label="操作人"
              min-width="200"
              align="center"
            />
            <el-table-column
              prop="createdWhen"
              label="操作时间"
              min-width="110"
              align="center"
            />
            <el-table-column
              prop="operationContent"
              label="操作事项"
              min-width="170"
              align="center"
            />
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="list-pagination">
          <ZD-pagination
            :pagination="pagination"
            v-on:pageUpdate="getListData"
          />
        </div>
      </div>

      <!-- 放电资费 -->
      <div class="disChange-body" v-else>
        <div class="body-item-title">车端放电资费设置</div>
        <div class="body-item-radio">
          <el-radio
            v-model="detailForm.chargeType"
            label="01"
            @change="handleRadioChange('01')"
            :disabled="isflag"
          >固定费用</el-radio>
          <el-input
            style="width:320px;"
            v-model="detailForm.ttlVal"
            size="small"
            @input="ttlValChange"
            :disabled="isflag"
          >
            <template slot="append">元/度</template>
          </el-input>
        </div>
        <div class="body-item-radio">
          <el-radio
              label="03"
              v-model="detailForm.chargeType"
              @change="handleRadioChange('03')"
              :disabled="isflag"
          >自定义分时电费</el-radio>
          <el-button
              type="primary"
              size="small"
              :disabled="isflag"
              @click="addTime"
              style="margin-right:10px;"
          >增加时间段</el-button>
        </div>
        <div class="body-item-timePeriod" style="justify-content: flex-start;">
          <div class="time-period-item item-font">时段区间</div>
          <div class="time-period-item item-font">放电资费</div>
          <div class="time-period-item item-font">操作</div>
        </div>
        <div class="body-item-timePeriod" v-for="(item, index) in items" :key="index">
          <div class="time-period-item">
            <Input v-model="item.startTime" :disabled="isflag" style="width: calc(50% - 20px)" />
            <div style="line-height: 32px; margin: 0 16px;">-</div>
            <TimePicker v-model="item.endTime" :editable="false" format="HH:mm" style="width: calc(50% - 20px)" :disabled="isflag" @on-change="chgStartTime(index)" />
          </div>
          <div class="time-period-item">
            <el-input style="width: calc(100% - 64px)" v-model="item.totalVal" size="small" :disabled="isflag"/>
          </div>
          <div class="time-period-item">
            <el-button type="primary" class="item-btn" @click="delTime(index)" :disabled="isflag">编 辑</el-button>
            <el-button type="primary" class="item-btn" @click="delTime(index)" :disabled="isflag">删 除</el-button>
          </div>
        </div>
        <div class="body-item-title">车端放电条件设置</div>
        <div class="body-item-soc">
          <div class="soc-title">最低放电量停止（车辆soc）</div>
          <el-input
              style="width:320px;"
              v-model="detailForm.ttlVal"
              size="small"
              @input="ttlValChange"
              :disabled="isflag"
          >
            <template slot="append">%</template>
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import config from "../../../config/config";
export default {
  data() {
    return {
      isflag: true,
      typeCode: "01",
      activeName: "acPile",
      pageConfig,
      editFlag: false,
      pageTitle: "资费新增",
      // 默认值设置
      detailForm: {},
      tableData: [],
      queryInfo: {
        operationBelongId: ""
      },
      pagination: pageConfig.pagination,
      valleyTime: ["00:00", "23:59"],
      peaksTime: ["23:59", "00:00"],
      customTime: [],
      tip1: "",
      tip2: "",
      tip3: "",
      items1: {
        startTime: "00:00",
        endTime: "00:00",
        charingcost: "",
        sercost: ""
      },
      items2: [
        {
          startTime: "",
          endTime: "",
          charingcost: "",
          sercost: ""
        },
        {
          startTime: "",
          endTime: "",
          charingcost: "",
          sercost: ""
        }
      ],
      items: [
        {
          startTime: "00:00",
          endTime: "",
          charingcost: "",
          sercost: "",
          tip: "",
          totalVal: ""
        }
      ],
      radioFlag1: false,
      radioFlag2: false,
      radioFlag3: false,
      flag1: false,
      flag21: false,
      flag22: false,
      flag3: false,
      zdytip: "",
      inputCheck: config.Reg.numberDecimal
    };
  },
  methods: {
    tabClick(val) {
      if (val.name === "acPile") {
        this.typeCode = "01";
      } else if (val.name === "dcPile") {
        this.typeCode = "02";
      } else if (val.name === "discharge") {
        this.typeCode = "02";
      } else {
        this.typeCode = "01";
      }
      this.getdetailForm();
      this.getListData(this.pagination, true);
    },
    //判断是否为编辑模式
    init() {
      this.isflag = !this.$S.checkUserMenu("pileStationChargeEdit");
      if (this.$store.state.stationObj) {
        this.editFlag = true;
        this.pageTitle = "资费详情";
        this.typeCode = "01";
        this.getdetailForm();
        this.getListData(this.pagination, true);
      }
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.operationBelongId = _.$store.state.stationObj.stationNo;
      _.$H.get(_, _.$A.pilestation.pileChargeLog, _.queryInfo).then(res => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
      });
    },
    // 获取表单信息
    getdetailForm() {
      let _ = this;
      _.$H
        .post(_, _.$A.pilestation.findno, {
          chargeNo: _.$store.state.stationObj.chargeNo,
          stationNo: _.$store.state.stationObj.stationNo,
          typeCode: _.typeCode
        })
        .then(res => {
          _.detailForm = res.data.data;
          if (res.data.data.chargeType === "01") {
            _.items1.charingcost = _.detailForm.fixedVal;
            if (_.detailForm.ttlVal - 0 == 0) {
              _.items1.sercost = 0;
            } else {
              _.items1.sercost = (
                _.detailForm.ttlVal - _.items1.charingcost
              ).toFixed(2);
            }
            _.radioFlag1 = false;
            _.radioFlag2 = true;
            _.radioFlag3 = true;
          } else if (res.data.data.chargeType === "02") {
            _.items2[1].charingcost = _.detailForm.baseVal;
            _.items2[0].charingcost = _.detailForm.highVal;
            _.valleyTime = [];
            _.peaksTime = [];
            _.valleyTime.push(_.detailForm.lowFrom);
            _.valleyTime.push(_.detailForm.lowTo);
            //峰值颠倒
            _.peaksTime.push(_.detailForm.lowTo);
            _.peaksTime.push(_.detailForm.lowFrom);
            if (_.detailForm.ttlVal - 0 == 0) {
              _.items2[0].sercost = 0;
              _.items2[1].sercost = 0;
            } else {
              _.items2[0].sercost = (
                _.detailForm.ttlVal - _.items2[0].charingcost
              ).toFixed(2);
              _.items2[1].sercost = (
                _.detailForm.ttlVal - _.items2[1].charingcost
              ).toFixed(2);
            }
            _.radioFlag1 = true;
            _.radioFlag2 = false;
            _.radioFlag3 = true;
          } else if (res.data.data.chargeType === "03") {
            _.radioFlag1 = true;
            _.radioFlag2 = true;
            _.radioFlag3 = false;
            _.items = JSON.parse(res.data.data.userDefined);
            for (var i = 0; i < _.items.length; i++) {
              _.items[i].charingcost = _.items[i].chargeVal;
              if (_.detailForm.ttlVal - 0 == 0) {
                _.items[i].sercost = 0;
              } else {
                _.items[i].sercost = (
                  _.items[i].totalVal - _.items[i].charingcost
                ).toFixed(2);
              }
            }
          }
        });
    },
    //切换电时费用
    handleRadioChange(radioVal) {
      let _ = this;
      if (radioVal == "01") {
        _.radioFlag1 = false;
        _.radioFlag2 = true;
        _.radioFlag3 = true;
      } else if (radioVal == "02") {
        _.radioFlag1 = true;
        _.radioFlag2 = false;
        _.radioFlag3 = true;
      } else {
        _.radioFlag1 = true;
        _.radioFlag2 = true;
        _.radioFlag3 = false;
      }
    },
    //选择时间
    handleTimeChange(val) {
      if (val) {
        this.peaksTime = [];
        this.peaksTime[0] = val[1];
        this.peaksTime[1] = val[0];
        this.items2[0].startTime = val[0];
        this.items2[0].endTime = val[1];
        this.items2[1].startTime = val[1];
        this.items2[1].endTime = val[0];
      }
    },
    //输入资费*元
    ttlValChange() {
      let _ = this;
      if (this.inputCheck.test(_.detailForm.ttlVal)) {
        if (_.detailForm.chargeType === "01") {
          _.handeleFeeChange1();
        } else if (_.detailForm.chargeType === "02") {
          _.handeleFeeChange21();
          _.handeleFeeChange22();
        } else if (_.detailForm.chargeType === "03") {
          _.handeleFeeChange3();
        }
      }
    },
    //输入基本电费
    handeleFeeChange1() {
      this.tip1 = "";
      this.flag1 = false;

      if (this.$U.isEmpty(this.items1.charingcost)) {
        //这里只是条件判断
        this.items1.sercost = "";
        this.tip1 = "请输入基本电费";
      } else if (this.inputCheck.test(this.items1.charingcost)) {
        if (this.detailForm.ttlVal - 0 == 0) {
          this.items1.sercost = 0;
          this.tip1 = "";
          this.flag1 = true;
        } else {
          if (this.items1.charingcost - this.detailForm.ttlVal > 0) {
            this.tip1 = "基本电费需小于等于资费";
            this.items1.sercost = "";
            return false;
          } else if (this.inputCheck.test(this.detailForm.ttlVal)) {
            this.items1.sercost = (
              this.detailForm.ttlVal - this.items1.charingcost
            ).toFixed(3);
            this.tip1 = "";
            this.flag1 = true;
          }
        }
      } else {
        this.tip1 = "请输入正确的数字(保留三位小数)";
      }
    },
    //请输入谷值基本电费
    handeleFeeChange21() {
      this.tip2 = "";
      this.flag21 = false;
      if (this.$U.isEmpty(this.items2[0].charingcost)) {
        //这里只是条件判断
        this.items2[0].sercost = "";
        this.tip2 = "请输入谷值基本电费";
        return;
      } else if (this.inputCheck.test(this.items2[0].charingcost)) {
        if (this.detailForm.ttlVal - 0 == 0) {
          this.tip2 = "";
          this.items2[0].sercost = 0;
          this.flag21 = true;
        } else {
          if (this.items2[0].charingcost - this.detailForm.ttlVal > 0) {
            this.tip2 = "谷值基本电费需小于等于资费";
            this.items2[0].sercost = "";
          } else {
            if (this.inputCheck.test(this.detailForm.ttlVal)) {
              this.items2[0].sercost = (
                this.detailForm.ttlVal - this.items2[0].charingcost
              ).toFixed(3);
              this.tip2 = "";
              this.flag21 = true;
            }
          }
        }
      } else {
        this.tip2 = "请输入正确的数字(保留三位小数)";
      }
    },
    // 输入峰值基本电费
    handeleFeeChange22() {
      this.tip3 = "";
      this.flag22 = false;
      if (this.$U.isEmpty(this.items2[1].charingcost)) {
        //这里只是条件判断
        this.items2[1].sercost = "";
        this.tip3 = "请输入峰值基本电费";
      } else if (this.inputCheck.test(this.items2[1].charingcost)) {
        if (this.detailForm.ttlVal - 0 == 0) {
          this.tip3 = "";
          this.items2[1].sercost = 0;
          this.flag22 = true;
        } else {
          if (this.items2[1].charingcost - this.detailForm.ttlVal > 0) {
            this.tip3 = "峰值基本电费需小于等于资费";
            this.items2[1].sercost = "";
          } else {
            if (this.inputCheck.test(this.detailForm.ttlVal)) {
              this.items2[1].sercost = (
                this.detailForm.ttlVal - this.items2[1].charingcost
              ).toFixed(3);
              this.tip3 = "";
              this.flag22 = true;
            }
          }
        }
      } else {
        this.tip3 = "请输入正确的数字(保留三位小数)";
      }
    },
    // 输入基本电费
    handeleFeeChange3() {
      this.flag3 = false;
      var mark = true;
      var len = this.items.length;
      for (var i = 0; i < len; i++) {
        this.items[i].tip = "";
        if (this.$U.isEmpty(this.items[i].charingcost)) {
          //这里只是条件判断
          this.items[i].sercost = "";
          this.items[i].tip = "需输入基本电费";
          mark = false;
        } else if (this.inputCheck.test(this.items[i].charingcost)) {
          if (this.detailForm.ttlVal - 0 == 0) {
            this.items[i].tip = "";
            this.items[i].sercost = 0;
          } else {
            if (this.items[i].charingcost - this.detailForm.ttlVal > 0) {
              this.items[i].tip = "基本电费需小于等于资费";
              this.items[i].sercost = "";
              mark = false;
            } else {
              if (this.inputCheck.test(this.detailForm.ttlVal)) {
                this.items[i].sercost = (
                  this.detailForm.ttlVal - this.items[i].charingcost
                ).toFixed(3);
                this.items[i].tip = "";
              } else {
                mark = false;
              }
            }
          }
        } else {
          this.items[i].tip = "请输入正确的数字(保留三位小数)";
          mark = false;
        }
      }
      if (mark == true) {
        this.flag3 = true;
      }
    },
    // 增加时间段
    addTime() {
      var len = this.items.length;

      if (this.items[len - 1].endTime == "23:59") {
        this.zdytip = "已达最大值";
      } else if (this.items[len - 1].endTime == "") {
        this.zdytip = "请选择时间";
      } else if (this.items[len - 1].endTime <= this.items[len - 1].startTime) {
        this.zdytip = "时间选择错误";
      } else {
        this.newitems = {};
        var endTime = this.items[len - 1].endTime;
        this.newitems.startTime = endTime;
        this.items.push(this.newitems);
        this.zdytip = "";
      }
    },
    //第二个时间选择器的触发事件
    chgStartTime(index) {
      var len = this.items.length;
      if (index < len - 1) {
        //不是最后一个

        if (this.items[index].endTime <= this.items[index].startTime) {
          //当前的时间结束大于开始
          this.items[index].endTime = this.items[index + 1].startTime;
          this.zdytip = "时间选择错误";
        }
        if (
          this.items[index + 1].endTime != "" &&
          this.items[index + 1].endTime <= this.items[index].endTime
        ) {
          this.items[index].endTime = this.items[index + 1].startTime;
          this.zdytip = "时间选择错误";
        } else {
          this.zdytip = "";
          this.items[index + 1].startTime = this.items[index].endTime;
          this.items = Object.assign([], this.items);
        }
      } else if ((index = len - 1)) {
        if (this.items[index].endTime <= this.items[index].startTime) {
          this.items[index].endTime = "23:59";
        }
      }
    },
    //删除某个时间
    delTime(index) {
      this.chgEndTime(index);
      this.items.splice(index, 1);
    },
    chgEndTime(index) {
      var len = this.items.length;
      if (index > 0 && index != len - 1) {
        this.items[index + 1].startTime = this.items[index - 1].endTime;
        this.items = Object.assign([], this.items);
      }
    },
    // 表单提交
    submitForm(formName) {
      let _ = this;
      _.detailForm.corpNo = _.$store.state.corpNo;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (_.detailForm.chargeType === "01") {
            _.handeleFeeChange1();
            if (_.flag1) {
              _.detailForm.fixedVal = _.items1.charingcost;
            }
          } else if (_.detailForm.chargeType === "02") {
            _.handeleFeeChange21();
            _.handeleFeeChange22();
            if (_.flag21 && _.flag22) {
              if (_.items2[0].startTime == "" || _.items2[0].endTime == "") {
                _.detailForm.lowFrom = _.valleyTime[0];
                _.detailForm.lowTo = _.valleyTime[1];
              } else {
                _.detailForm.lowFrom = _.items2[0].startTime;
                _.detailForm.lowTo = _.items2[0].endTime;
              }
              _.detailForm.baseVal = _.items2[1].charingcost;
              _.detailForm.highVal = _.items2[0].charingcost;
            }
          } else {
            _.handeleFeeChange3();
            if (_.flag3) {
              let len = _.items.length;
              let jsonArr = [];
              for (var i = 0; i < len; i++) {
                jsonArr[i] =
                  _.items[i].startTime +
                  ";" +
                  _.items[i].endTime +
                  ";" +
                  _.items[i].charingcost;
              }
              _.detailForm.customizeTimes = jsonArr;
            }
          }
          _.detailForm.stationNo = this.$store.state.stationObj.stationNo;
          _.$H.put(_, _.$A.pilestation.pilecharge, _.detailForm).then(res => {
            _.$U.success("保存成功");
            this.$router.push({
              name: pageConfig.listRouter
            });
          });
        }
      });
    },
    // 取消
    resetForm() {
      this.$router.push({
        name: pageConfig.listRouter
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
